/*
 * SPDX-License-Identifier: Apache-2.0
 *
 * The OpenSearch Contributors require contributions made to
 * this file be licensed under the Apache-2.0 license or a
 * compatible open source license.
 *
 * Modifications Copyright OpenSearch Contributors. See
 * GitHub history for details.
 */

import React, { useState, useEffect } from 'react';
import PropTypes from "prop-types";
import { OuiCodeBlock } from '../../../../../src/components/code';
// @ts-ignore Not TS
import { renderJsSourceCode } from '../_utils';
export var GuideSectionExampleCode = ({
  code
}) => {
  const [codeToRender, setCodeToRender] = useState();
  useEffect(() => {
    setCodeToRender(renderJsSourceCode(code));
    return () => {
      setCodeToRender(undefined);
    };
  }, [code]);
  return <>
      <OuiCodeBlock language="jsx" overflowHeight={400} isCopyable>
        {codeToRender}
      </OuiCodeBlock>
    </>;
};
GuideSectionExampleCode.propTypes = {
  code: PropTypes.any.isRequired
};
try {
  GuideSectionExampleCode.__docgenInfo = {
    tags: {},
    filePath: '/codebuild/output/src2210237963/src/src-docs/src/components/guide_section/guide_section_parts/guide_section_code.tsx',
    description: '',
    displayName: 'GuideSectionExampleCode',
    methods: [],
    props: {
      code: {
        defaultValue: null,
        description: '',
        name: 'code',
        parent: undefined,
        declarations: [{
          fileName: 'src/src-docs/src/components/guide_section/guide_section_parts/guide_section_code.tsx',
          name: 'TypeLiteral'
        }],
        required: true,
        type: {
          name: 'any'
        }
      }
    },
    extendedInterfaces: []
  };
} catch (e) {}